<template>
  <v-data-table
    :footer-props="footer"
    :headers="headers"
    :items.sync="items"
    :loading="loading"
    :options.sync="options"
    :server-items-length="totalItems"
    class="elevation-0"
    item-key="id"
    sortable="false"
  >
    <template #item.created_at="{ item }">
      <span
        class="d-block mt-1 text-monospace"
        style="font-size: 0.8em; min-width: 140px"
      >{{ $moment(item.created_at).format("YYYY-MM-DD HH:mm:ss") }}</span>
      <v-chip
        pill
        class="pa-1 mb-1"
        x-small
        color="light"
      >
        {{
          $moment(item.created_at).fromNow()
        }}
      </v-chip>
    </template>
    <template #item.transactionable_type="{ item }">
      <PointType
        :item_type="item.type"
        :item_transactionable="item.transactionable_type"
        :item_remark="item.remark"
      />
    </template>
    <template #item.amount="{ item }">
      <span
        v-if="item.type.match(/debit/g)"
        class="text-monospace text-right text-success d-block"
      >{{
        item.amount.toLocaleString("en-US", {
          maximumFractionDigits: 2,
          minimumFractionDigits: 2,
        })
      }}</span>
      <span
        v-else-if="item.type.match(/credit/g)"
        class="text-monospace text-right text-danger d-block"
      >-{{
        item.amount.toLocaleString("en-US", {
          maximumFractionDigits: 2,
          minimumFractionDigits: 2,
        })
      }}</span>
    </template>
  </v-data-table>
</template>

<script>
import axios from 'axios';
import _ from 'lodash';
import Vue from 'vue';
import PointType from './point-type.vue';

export default {
  name: 'PointTable',
  components: { PointType },
  props: {
    userId: { required: true, default: null },
  },
  data() {
    return {
      options: {},
      loading: true,
      items: [],
      totalItems: 0,
      headers: [
        {
          text: 'วันที่',
          value: 'created_at',
          align: 'center',
          justify: 'center',
        },
        {
          text: 'รายการ',
          value: 'transactionable_type',
          align: 'center',
          justify: 'center',
        },
        { text: 'จำนวน', value: 'amount', align: 'center' },
      ],
      footer: {
        disableItemsPerPage: true,
        itemsPerPageOptions: [],
        showCurrentPage: true,
      },
    };
  },
  watch: {
    options: {
      handler() {
        this.fetchData();
      },
      deep: true,
    },
  },
  methods: {
    CancelToken: axios.CancelToken,
    fetchData() {
      if (this.userId) {
        this.loading = true;
        if (this.axiosCanceller) {
          this.axiosCanceler();
        }
        axios
          .get(`/api/user/${this.userId}/point`, {
            params: {
              page: this.options.page,
            },
            cancelToken: new axios.CancelToken((c) => {
              this.axiosCanceler = c;
            }),
          })
          .then((response) => {
            Vue.set(this, 'items', response.data.data);
            Vue.set(this, 'totalItems', response.data.total);
            Vue.set(this.options, 'page', response.data.current_page);
          })
          .catch((e) => console.error(e))
          .finally(() => {
            this.loading = false;
          });
      }
    },
  },
};
</script>
